import Vue from "vue";
import Vuex from "vuex";
import auth from "./auth.module";
import patients from "./patients.module";
import clinician from "./clinician.module";
import fitbit from "./fitbit.module";
import organizations from "./organizations.module";
import procedures from "./procedures.module";
import roles from "./roles.module";
import surveys from "./surveys.module";
import education from "./education.module";
import users from "./users.module";
import openpatient from "./openpatient.modules";
import agreement from "./agreement.module";
import authenticatedglobals from "./authenticatedglobals.module";
import globals from "./globals.module";
import timetracking from "./timetracking.module";
import devicedata from "./devicedata.module";
import fhir from "./fhir.module";
import admindevice from "./admindevices.module";
import compliance from "./compliance.module";
import appointment from "./appointment.module";


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    patients,
    clinician,
    fitbit,
    organizations,
    procedures,
    openpatient,
    roles,
    surveys,
    education,
    users,
    agreement,
    globals,
    timetracking,
    devicedata,
    authenticatedglobals,
    fhir,
    admindevice,
    compliance,
    appointment
  },
});